import { Injectable } from '@angular/core';

import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';

@Injectable()
export class MarketcopyAssignedSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();

  assetId: string = '';

  // public:
  getSearchURI(brandId: string, searchModel: SearchModel): string {
    return `/assets/${brandId}/${this.assetId}/marketcopy-assignments`;
  }

  getQueryString(searchModel: SearchModel): string {
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';
    const queryString: string =
      'page=' + searchModel.currentPage +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + searchModel.searchValue +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir;

    return queryString;
  }

  runSearchMarketcopyAssigned(brandId: string, assetId: string): Promise<any> {
    this.assetId = assetId;
    return new Promise<void>(resolve => {
      this.runSearch(brandId, this.searchModel)
      .subscribe((searchResults: any) => {
        resolve();
      });
    });
  }

  clearSearchModel() {
    this.searchModel = new SearchModel();
  }
}
